import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/AlertDialog/AlertDialog";
import { VStack } from "@/components/layout/VStack";
import { format } from "date-fns";

const MultiSessionConfirmDialog = ({
  open,
  onOpenChange,
  onConfirm,
  exploration,
  siblings,
  sessions,
  rotations,
  variant,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  onConfirm: () => void;
  exploration: any;
  siblings: any[];
  sessions: any[];
  rotations: any[];
  variant: "singleton" | "preference";
}) => {
  const sessionById = new Map(sessions.map((s) => [String(s._id), s]));
  const rotationById = new Map(rotations.map((r) => [String(r._id), r]));

  const siblingRows = siblings.map((sib) => {
    const session = sessionById.get(String(sib.session));
    const rotation = session
      ? rotationById.get(String(session.rotation))
      : null;
    const dates = session?.singleton
      ? rotation
        ? [rotation.date]
        : []
      : (session?.selectedDates ?? []);
    return {
      key: String(sib._id),
      sessionName: session?.name ?? "(unknown session)",
      dates: dates as (string | Date)[],
    };
  });

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Multi-session exploration</AlertDialogTitle>
          <AlertDialogDescription>
            {variant === "singleton"
              ? `Signing up for "${exploration.name}" will enroll you in all ${siblings.length} linked sessions. You won't be able to change this without contacting a teacher.`
              : `"${exploration.name}" runs across ${siblings.length} sessions. Confirming makes it your top preference in all of them — you'll still pick your 2nd and 3rd choices for each session.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <VStack gap="0.5rem" style={{ marginBlock: "0.5rem" }}>
          {siblingRows.map((row) => (
            <VStack key={row.key} gap="2px">
              <span style={{ fontWeight: 600, fontSize: "0.875rem" }}>
                {row.sessionName}
              </span>
              {row.dates.length > 0 && (
                <span
                  style={{
                    fontSize: "0.75rem",
                    color: "var(--muted-foreground)",
                  }}
                >
                  {row.dates
                    .map((d) => format(new Date(d), "MMM d, yyyy"))
                    .join(", ")}
                </span>
              )}
            </VStack>
          ))}
        </VStack>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Continue</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export { MultiSessionConfirmDialog };
